import { useMutation } from "@tanstack/react-query";

import { useStoreAPI } from "shared/services/api";
import { ConfirmUserEmailRequest, SendConfirmUserEmailRequest } from "shared/services/api/store";

import { useAuthContext } from "~/features/auth";

export const useEmailConfirmation = () => {
  const { accessToken, refetch } = useAuthContext();
  const api = useStoreAPI({ accessToken });

  const { mutateAsync: confirmEmail, isLoading: isConfirmEmailLoading } = useMutation(
    ["users/confirmations/email"],
    (data: ConfirmUserEmailRequest) => api.confirmUserEmail(data),
    {
      onSuccess: () => {
        refetch();
      },
    },
  );

  const { mutateAsync: sendConfirmationMail, isLoading: isSendConfirmationEmailLoading } = useMutation(
    ["users/confirmations/email/send"],
    (data: SendConfirmUserEmailRequest) => api.sendConfirmUserEmail(data),
  );

  return {
    confirmEmail,
    sendConfirmationMail,
    isConfirmEmailLoading,
    isSendConfirmationEmailLoading,
    isFetching: isConfirmEmailLoading || isSendConfirmationEmailLoading,
  };
};
